import { render, staticRenderFns } from "./CardFuncionario.vue?vue&type=template&id=4dfb5a6e&scoped=true&"
import script from "./CardFuncionario.vue?vue&type=script&lang=js&"
export * from "./CardFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./CardFuncionario.vue?vue&type=style&index=0&id=4dfb5a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb5a6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
